import script from "./SkeletAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletAvatar.vue?vue&type=script&setup=true&lang=js"

import "./SkeletAvatar.vue?vue&type=style&index=0&id=18f9f50e&lang=scss"

const __exports__ = script;

export default __exports__